import { CSSInterpolation } from '@mui/material';

export const firmwareTableStyles: CSSInterpolation = {
  'tr > th:first-of-type, tr > td:first-of-type': {
    '@media(max-width: 1024px)': {
      minWidth: '50px',
      width: '50px',
    },
  },
  'tr > th:last-of-type, tr > td:last-of-type': {
    '@media(max-width: 1024px)': {
      minWidth: '120px',
      width: '120px',
    },
  },
  'tr > th:not(:last-of-type):not(:first-of-type), tr > td:not(:last-of-type):not(:first-of-type)':
    {
      '@media(max-width: 1024px)': {
        minWidth: '1439px',
        width: '1439px',
      },
    },
  'tbody tr td:first-of-type > span:first-of-type': {
    top: '35%',
  },
  'tr > td:last-of-type': {
    verticalAlign: 'top',
  },
};
